import { debounceTime } from 'rxjs/operators';
import { ComponentSelectionStorageService } from '@sdbn/common';
import { FormControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import { Component, OnInit, EventEmitter, Output, OnDestroy, ViewEncapsulation } from '@angular/core';
import { ContextChange } from '@sdbn/common';
import { AbstractWidgetComponent, WidgetStyle } from '@sdbn/common';
import { TranslationService } from '@sdbn/common';
import { TruckOverviewFilterModel } from '../truck-overview.model';


const CUSTOM_FILTER_SELECTION_KEY = 'truck-overview.custom-filter-selection';


@Component({
  selector: 'app-truck-overview-filter',
  templateUrl: './truck-overview-filter.component.html',
  styleUrls: ['./truck-overview-filter.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class TruckOverviewFilterComponent extends AbstractWidgetComponent implements OnInit, OnDestroy {

  selectedCustomFilter: number;

  textFilterFormControl = new FormControl();

  filterTextFieldSubscription: Subscription;

  constructor(
    public translationService: TranslationService,
    private componentSelectionStorageService: ComponentSelectionStorageService) {
    super();
  }

  ngOnInit() {

    this.registerFilterTextfieldSubscription();

    this.registerFilterTextfieldSubscription();

    this.restoreFilter();
  }

  ngOnDestroy() {

    super.ngOnDestroy();

    if (this.filterTextFieldSubscription != null) {
      this.filterTextFieldSubscription.unsubscribe();
    }
  }

  private registerFilterTextfieldSubscription() {
    // prevent double subscriptions
    this.deregisterFilterTextfieldSubscription();

    // debounce time of 300ms to prevent an event per keystroke
    this.filterTextFieldSubscription = this.textFilterFormControl.valueChanges.pipe(debounceTime(300)).subscribe(
      value => {
        this.handleFilterChanged();
      }
    );
  }

  private deregisterFilterTextfieldSubscription() {
    if (this.filterTextFieldSubscription != null) {
      this.filterTextFieldSubscription.unsubscribe();
    }
  }

  private restoreFilter() {

    try {
      const model: TruckOverviewFilterModel = this.componentSelectionStorageService.get(CUSTOM_FILTER_SELECTION_KEY);

      if (model != null) {
        // restore text filter
        if (model.filterText != null) {
          try {
            // deregister textfield subscription to prevent event while restoring the filters
            this.deregisterFilterTextfieldSubscription();
            this.textFilterFormControl.setValue(model.filterText);
          } finally {
            this.registerFilterTextfieldSubscription();
          }
        }
      }
    } finally {
      this.handleFilterChanged();
    }
  }

  private handleFilterChanged() {
    /** we need to fire a new model instance, otherwise the destined input will not react to changes properly */
    const model = new TruckOverviewFilterModel();
    model.filterText = this.textFilterFormControl.value;
    this.componentSelectionStorageService.save(CUSTOM_FILTER_SELECTION_KEY, model);
    this.dashboardContext.setContextValue('truck-selection', model);
  }

  onContextChange(contextChange: ContextChange) {
  }

  onSetElementAndContext() {
  }

  getStyle(): WidgetStyle {
    return WidgetStyle.transparent;
  }
}
